export enum IconName {
  Apartment = 'apartment',
  DirectionsCarOutlined = 'directionsCarOutlined',
  ElectricBolt = 'electricBolt',
  ShoppingCartOutlined = 'shoppingCartOutlined',
  BuildOutlined = 'buildOutlined',
  LocalGasStationOutlined = 'localGasStationOutlined',
  LocalShippingOutlined = 'localShippingOutlined',
  DeleteOutlineOutlined = 'deleteOutlineOutlined',
  Flight = 'flight',
  DirectionsWalk = 'directionsWalk',
  AssignmentOutlined = 'assignmentOutlined',
  Assignment = 'assignment',
  MonetizationOn = 'monetizationOn',
  Store = 'store',
  ShoppingBagOutlined = 'shoppingBagOutlined',
  Recycling = 'recycling',
  FactoryOutlined = 'factoryOutlined',
  Star = 'starOutlined',
  EnergySavingsLeafOutlined = 'energySavingsLeafOutlined',
  AcUnitOutlined = 'acUnitOutlined',
  ElectricCarOutlined = 'electricCarOutlined',
  OpacityOutlined = 'opacityOutlined',
  WaterOutlined = 'waterOutlined',
  DeleteOutline = 'deleteOutline',
  AirplanemodeActiveOutlined = 'airplanemodeActiveOutlined',
  DirectionsBoatOutlined = 'directionsBoatOutlined',
  HotelOutlined = 'hotelOutlined',
  HomeWorkOutlined = 'homeWorkOutlined',
  RemoveCircleOutlineOutlined = 'removeCircleOutlineOutlined',
  Done = 'done',
  PedalBike = 'pedalBike',
  LocalTaxi = 'localTaxi',
  DirectionsBus = 'directionsBus',
  Train = 'train',
  TwoWheeler = 'twoWheeler',
  ElectricScooter = 'electricScooter',
  SpaceDashboardOutlined = 'spaceDashboardOutlined',
  SpaceDashboard = 'spaceDashboard',
  AccountBalanceOutlined = 'accountBalanceOutlined',
  AccountBalance = 'accountBalance',
  FilterDrama = 'filterDrama',
  Cloud = 'cloud',
  CloudOutlined = 'cloudOutlined',
  StackedBarChartOutlined = 'stackedBarChartOutlined',
  StackedBarChart = 'stackedBarChart',
  DescriptionOutlined = 'DescriptionOutlined',
  Description = 'description',
  AdminPanelSettingsOutlined = 'adminPanelSettignsOutlined',
  AdminPanelSettings = 'adminPanelSettings',
  CheckCircle = 'checkCircle',
  CheckCircleOutlined = 'checkCircleOutlined',
  RotateRight = 'rotateRight',
  PollOutlined = 'pollOutlined',
  Poll = 'poll',
  BallotOutlined = 'ballotOutlined',
  Ballot = 'ballot',
  CalendarMonthOutlined = 'calendarMonthOutlined',
  TonalityOutlined = 'tonalityOutlined',
  CircleOutlined = 'circleOutlined',
  TrendingDown = 'trendingDown',
  ArrowForwardIos = 'arrowForwardIos',
  Add = 'add',
  LocalFireDepartmentOutlined = 'localFireDepartmentOutlined',
  HeatPumpOutlined = 'heatPumpOutlined',
  SolarPowerOutlined = 'solarPowerOutlined',
  WindPowerOurlined = 'windPowerOutlined',
  HvacOutlined = 'hvacOutlined',
  HouseOutlined = 'houseOutlined',
  ThermostatOutlined = 'thermostatOutlined',
  LightbulbOutlined = 'lightbulbOutlined',
  MicrowaveOutlined = 'microwaveOutlined',
  ElectricBoltOutlined = 'electricBoltOutlined',
  HandshakeOutlined = 'handshakeOutlined',
  RecyclingOutlined = 'recyclingOutlined',
  ApartmentOutlined = 'apartmentOutlined',
  TrainOutlined = 'trainOutlined',
  DirectionsBusOutlined = 'directionsBusOutlined',
  DirectionsBikeOutlined = 'directionsBikeOutlined',
  SummarizeOutlined = 'summarizeOutlined',
  Factory = 'factory',
  Inventory2Outlined = 'inventory2Outlined',
  Inventory2 = 'inventory2',
  ErrorOutline = 'errorOutline',
  Business = 'business',
  AccountTree = 'accountTree',
  UploadOutlined = 'uploadOutlined',
  HighlightOff = 'highlightOff',
  EditOutlined = 'editOutlined',
  Check = 'check',
  Clear = 'clear',
  CancelOutlined = 'cancelOutlined',
  ManageAccounts = 'manageAccounts',
  Login = 'login',
  InfoOutlined = 'infoOutlined',
  StarBorderOutlined = 'starBorderOutlined',
  Autorenew = 'autorenew',
  PublishedWithChangesRounded = 'publishedWithChangesRounded',
  VerifiedUser = 'verifiedUser',
  VerifiedUserOutlined = 'verifiedUserOutlined',
  Lock = 'lock',
  LockOutlined = 'lockOutlined',
  Security = 'security',
  SecurityOutlined = 'securityOutlined',
  Scale = 'scale',
  CurrencyPound = 'currencyPound',
  HideSourceOutlined = 'hideSourceOutlined',
  EditNote = 'editNote',
  CalculateOutlined = 'calculateOutlined',
  EmailOutlined = 'emailOutlined',
  ReceiptLongOutlined = 'receiptLongOutlined',
  MenuBook = 'menuBook',
  MenuBookOutlined = 'menuBookOutlined',
  FactCheck = 'factCheck',
  FactCheckOutlined = 'factCheckOutlined',
}